if (!customElements.get('nido-bundle-builder')) {
  customElements.define(
    'nido-bundle-builder',
    class NidoBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.quantity = 1;
        this.submitButton = this.querySelector('[data-submit]');
        this.errorBox = this.querySelector('[data-error]');
        this.caseArea = this.querySelector('[data-case-area]');
        this.caseRows = this.querySelector('[data-case-rows]');
        this.extraSlots = this.querySelector('[data-extra-size-slots]');
        this.mixedArea = this.querySelector('[data-mixed-sizes]');
        this.bindEvents();
        this.setInitialSize();
        this.updatePrices();
        this.setupStickyButton();
      }

      bindEvents() {
        this.addEventListener('click', (event) => {
          const size = event.target.closest('[data-variant-id]');
          const offer = event.target.closest('[data-quantity]');
          const caseChoice = event.target.closest('[data-case-choice]');

          if (size) this.selectSize(size);
          if (offer) this.selectQuantity(Number(offer.dataset.quantity));
          if (caseChoice) this.selectCaseMode(caseChoice.dataset.caseChoice);
          if (event.target.closest('[data-add-case]')) this.addCaseRow();
          if (event.target.closest('[data-remove-case]')) {
            event.target.closest('.nido-bundle__case-row')?.remove();
            if (!this.caseRows.children.length) this.addCaseRow();
            this.updatePrices();
          }
          if (event.target.closest('[data-case-minus]')) this.changeCaseQuantity(event.target.closest('.nido-bundle__case-row'), -1);
          if (event.target.closest('[data-case-plus]')) this.changeCaseQuantity(event.target.closest('.nido-bundle__case-row'), 1);
          if (event.target.closest('[data-submit]')) this.addToCart();
          if (event.target.closest('[data-sticky-button]')) this.scrollToBuilder();
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('.nido-bundle__case-select, .nido-bundle__case-quantity input')) this.updatePrices();
        });
      }

      setInitialSize() {
        const selected = this.querySelector('[data-size-slot="1"] .nido-bundle__choice.is-selected') || this.querySelector('[data-size-slot="1"] .nido-bundle__choice:not(:disabled)');
        if (selected) this.selectSize(selected);
      }

      selectSize(button) {
        const group = button.closest('.nido-bundle__sizes');
        group.querySelectorAll('.nido-bundle__choice').forEach((choice) => {
          const active = choice === button;
          choice.classList.toggle('is-selected', active);
          choice.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (group.dataset.sizeSlot === '1') {
          const detail = this.querySelector('[data-size-detail]');
          if (detail) detail.textContent = button.dataset.detail || '';
        }
        this.updatePrices();
      }

      selectQuantity(quantity) {
        this.quantity = quantity;
        this.querySelectorAll('[data-quantity]').forEach((offer) => {
          const active = Number(offer.dataset.quantity) === quantity;
          offer.classList.toggle('is-selected', active);
          offer.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.renderExtraSizeSlots();
        this.updatePrices();
      }

      renderExtraSizeSlots() {
        this.extraSlots.replaceChildren();
        this.mixedArea.hidden = this.quantity === 1;
        if (this.quantity === 1) return;

        const template = this.querySelector('[data-size-slot-template]');
        const primary = this.getSelectedSize(this.querySelector('[data-size-slot="1"]'));
        for (let index = 2; index <= this.quantity; index += 1) {
          const fragment = template.content.cloneNode(true);
          const slot = fragment.querySelector('.nido-bundle__slot');
          const group = fragment.querySelector('.nido-bundle__sizes');
          slot.dataset.slot = String(index);
          group.dataset.sizeSlot = String(index);
          group.setAttribute('aria-label', `Almohada ${index}`);
          fragment.querySelector('.nido-bundle__slot-label').textContent = `Almohada ${index}`;
          const matching = group.querySelector(`[data-variant-id="${primary?.dataset.variantId || ''}"]`) || group.querySelector('.nido-bundle__choice:not(:disabled)');
          if (matching) {
            matching.classList.add('is-selected');
            matching.setAttribute('aria-pressed', 'true');
          }
          this.extraSlots.appendChild(fragment);
        }
      }

      selectCaseMode(mode) {
        this.querySelectorAll('[data-case-choice]').forEach((choice) => {
          const active = choice.dataset.caseChoice === mode;
          choice.classList.toggle('is-selected', active);
          choice.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.caseArea.hidden = mode !== 'add';
        if (mode === 'add' && !this.caseRows.children.length) this.addCaseRow();
        this.updatePrices();
      }

      addCaseRow() {
        const template = this.querySelector('[data-case-row-template]');
        const fragment = template.content.cloneNode(true);
        const select = fragment.querySelector('select');
        if (!select.options.length) {
          this.showError('Choose the available pillowcase products in the theme editor first.');
          return;
        }
        this.caseRows.appendChild(fragment);
        this.updatePrices();
      }

      changeCaseQuantity(row, change) {
        const input = row?.querySelector('input');
        if (!input) return;
        input.value = String(Math.max(1, Number(input.value || 1) + change));
        this.updatePrices();
      }

      getSelectedSize(group) {
        return group?.querySelector('.nido-bundle__choice.is-selected');
      }

      getPillowSelections() {
        return Array.from(this.querySelectorAll('.nido-bundle__sizes[data-size-slot]'))
          .filter((group) => Number(group.dataset.sizeSlot) <= this.quantity)
          .map((group) => this.getSelectedSize(group))
          .filter(Boolean);
      }

      getCaseSelections() {
        if (this.caseArea.hidden) return [];
        return Array.from(this.caseRows.querySelectorAll('.nido-bundle__case-row')).map((row) => {
          const select = row.querySelector('select');
          const option = select.options[select.selectedIndex];
          return {
            id: Number(select.value),
            quantity: Math.max(1, Number(row.querySelector('input').value || 1)),
            price: Number(option?.dataset.price || 0),
          };
        });
      }

      getOffer(quantity) {
        const offer = this.querySelector(`[data-quantity="${quantity}"]`);
        const code = (offer?.dataset.discountCode || '').trim();
        const percent = (code || this.dataset.discountMode === 'automatic') ? Math.min(100, Math.max(0, Number(offer?.dataset.discountPercent) || 0)) : 0;
        return { quantity, code, percent };
      }

      discountedPrice(cents, quantity) {
        return Math.round(cents * (100 - this.getOffer(quantity).percent) / 100);
      }

      updatePrices() {
        const primary = this.getSelectedSize(this.querySelector('[data-size-slot="1"]'));
        const primaryPrice = Number(primary?.dataset.price || 0);
        const pillowTotal = this.getPillowSelections().reduce((sum, choice) => sum + Number(choice.dataset.price || 0), 0);
        this.querySelectorAll('[data-offer-price]').forEach((element) => {
          const offerQuantity = Number(element.dataset.offerPrice);
          const original = offerQuantity === this.quantity ? pillowTotal : primaryPrice * offerQuantity;
          const discounted = this.discountedPrice(original, offerQuantity);
          element.textContent = this.formatMoney(discounted);
          const originalLabel = this.querySelector(`[data-offer-original="${offerQuantity}"]`);
          if (originalLabel) {
            originalLabel.textContent = this.formatMoney(original);
            originalLabel.hidden = discounted >= original;
          }
        });

        const caseTotal = this.getCaseSelections().reduce((sum, choice) => sum + choice.price * choice.quantity, 0);
        const total = this.querySelector('[data-total-price]');
        const discounted = this.discountedPrice(pillowTotal, this.quantity);
        if (total) total.textContent = this.formatMoney(discounted + caseTotal);
        const savings = this.querySelector('[data-bundle-savings]');
        if (savings) {
          savings.hidden = discounted >= pillowTotal;
          savings.textContent = `Ahorras ${this.formatMoney(pillowTotal - discounted)} en tus almohadas`;
        }
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const value = (cents / 100).toFixed(2);
        const parts = value.split('.');
        const withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const replacements = {
          '{{amount}}': `${withThousands}.${parts[1]}`,
          '{{amount_no_decimals}}': withThousands,
          '{{amount_with_comma_separator}}': `${withThousands.replace(/,/g, '.')},${parts[1]}`,
          '{{amount_no_decimals_with_comma_separator}}': withThousands.replace(/,/g, '.'),
        };
        return Object.entries(replacements).reduce((output, [token, replacement]) => output.replace(token, replacement), format);
      }

      buildItems() {
        const grouped = new Map();
        this.getPillowSelections().forEach((choice) => {
          const id = Number(choice.dataset.variantId);
          grouped.set(id, (grouped.get(id) || 0) + 1);
        });
        this.getCaseSelections().forEach((choice) => grouped.set(choice.id, (grouped.get(choice.id) || 0) + choice.quantity));
        return Array.from(grouped, ([id, quantity]) => ({ id, quantity }));
      }

      async applyBundleDiscounts(cart, data) {
        if (this.dataset.discountMode === 'automatic') return data;
        const offers = [2, 3].map((quantity) => this.getOffer(quantity)).filter((offer) => offer.code && offer.percent > 0);
        if (!offers.length) return data;
        const root = window.Shopify?.routes?.root || '/';
        const stateResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!stateResponse.ok) throw new Error('No pudimos verificar el descuento. Revisa el total antes de pagar.');
        const state = await stateResponse.json();
        const ids = new Set(Array.from(this.querySelectorAll('[data-size-slot="1"] [data-variant-id]'), (choice) => Number(choice.dataset.variantId)));
        const quantity = state.items.reduce((sum, item) => sum + (ids.has(item.variant_id) ? item.quantity : 0), 0);
        const best = offers.filter((offer) => quantity >= offer.quantity).sort((a, b) => b.percent - a.percent)[0];
        const managed = new Set(offers.map((offer) => offer.code.toLowerCase()));
        const existingAllocations = state.items.flatMap((item) => item.line_level_discount_allocations || []);
        const existingApplications = (state.cart_level_discount_applications || []).concat(existingAllocations.map((allocation) => allocation.discount_application));
        const existingCodes = (state.discount_codes || []).map((discount) => discount.code).concat(
          existingApplications.filter((discount) => discount?.type === 'discount_code').map((discount) => discount.title)
        );
        const codes = [...new Set(existingCodes)].filter((code) => code && !managed.has(code.toLowerCase()));
        if (best) codes.push(best.code);
        const payload = { discount: [...new Set(codes)].join(',') };
        if (cart?.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }
        const response = await fetch(this.dataset.cartUpdateUrl || `${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const updated = await response.json();
        if (!response.ok || updated.status) throw new Error('No pudimos aplicar el descuento. Revisa el total antes de pagar.');
        if (best) {
          const applied = (updated.discount_codes || []).some((discount) => discount.code.toLowerCase() === best.code.toLowerCase() && discount.applicable === true);
          const allocations = updated.items.flatMap((item) => item.line_level_discount_allocations || []).concat(
            (updated.cart_level_discount_applications || []).map((discount_application) => ({ discount_application }))
          );
          const allocated = allocations.some(({ discount_application: discount }) => discount?.type === 'discount_code' && discount.title?.toLowerCase() === best.code.toLowerCase());
          if (!applied && !allocated) updated.bundleDiscountWarning = 'El descuento del pack no está disponible. Revisa el total antes de pagar.';
        }
        return updated;
      }

      async addToCart() {
        if (this.isSubmitting) return;
        const items = this.buildItems();
        if (this.getPillowSelections().length !== this.quantity) {
          this.showError('Elige el tamaño de cada almohada.');
          return;
        }
        this.isSubmitting = true;
        this.showError('');
        this.submitButton.disabled = true;
        this.submitButton.classList.add('is-loading');
        const cart = document.querySelector('cart-drawer');
        const payload = { items };
        if (cart?.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cart.setActiveElement?.(this.submitButton);
        }
        let added = false;
        try {
          const response = await fetch(this.dataset.cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          let data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'No pudimos agregar los productos al carrito.');
          added = true;
          try {
            data = await this.applyBundleDiscounts(cart, data);
          } catch (error) {
            data.bundleDiscountWarning = error.message;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nido-bundle-builder', productVariantId: items[0]?.id, cartData: data });
          }
          const sectionsReady = cart?.getSectionsToRender?.().every((section) => typeof data.sections?.[section.id] === 'string');
          if (cart?.renderContents && sectionsReady) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
            if (data.bundleDiscountWarning) {
              const warning = document.createElement('p');
              warning.setAttribute('role', 'alert');
              warning.textContent = data.bundleDiscountWarning;
              cart.querySelector('.drawer__footer')?.prepend(warning);
            }
          } else {
            window.location.href = this.dataset.cartPage;
          }
        } catch (error) {
          if (added) window.location.href = this.dataset.cartPage;
          else this.showError(error.message);
        } finally {
          this.isSubmitting = false;
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-loading');
        }
      }

      showError(message) {
        this.errorBox.textContent = message;
        this.errorBox.hidden = !message;
      }

      setupStickyButton() {
        const sticky = this.querySelector('[data-sticky]');
        if (!sticky || !this.submitButton) return;
        this.stickyObserver = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        this.stickyObserver.observe(this.submitButton);
      }

      scrollToBuilder() {
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      disconnectedCallback() {
        this.stickyObserver?.disconnect();
      }
    }
  );
}
